import { createFileRoute } from "@tanstack/react-router";
import { AttributesContainer } from "@/features/attributes";

export const Route = createFileRoute("/$store/_layout/attributes")({
	component: AttributesPage,
});

function AttributesPage() {
	return <AttributesContainer />;
}
